import React from 'react';
import { Button, Jumbotron, Container, Figure} from 'react-bootstrap';
import {RDownload} from '@putil-view/item.components';
import { useScreen } from '@putil-view/use.use-screen';
import { SysPath } from 'SysContext';
import PropTypes from 'prop-types';
export const DisplayResult = ({state, onRestart})=>{
	const screen = useScreen();
	const getImgByPathUrl = SysPath.getImgByPathUrl;
	const getVideoByPathUrl = SysPath.getVideoByPathUrl;
	const obj = {
		'Locker Apperance Image' : state.result.locker_apperance_path,
		'Locker Items Image': state.result.locker_items_path,
		'Locker Items Cleared':state.result.locker_items_cleared_path,
		'Locker Video':state.result.locker_video_path
	}
	const previewFileStyle = {
		height: screen.isWideScreen ?'50vh':'45vh',
		width:  screen.isWideScreen ?'50vh':'100%',
		display:'flex',
		justifyContent: 'center',
		objectFit: 'cover'
	};
	return (
		<>
			{state.result
					?
						<Jumbotron fluid>
							<Container>
								<h1 className="display-5 text-center" >Upload Successful</h1>
								<br/>
									<Button variant='dark' block className="text-center" onClick={onRestart}>Next Locker</Button>
								<br/>
								<p className="lead text-center">Below unlock images of {state.scanText} are uploaded.</p>
								<div className="text-center">

									{['Locker Apperance Image', 'Locker Items Image', 'Locker Items Cleared'].map(prop => {
										return (
										<>
										<Figure>
											<RDownload fileName={prop+".png"} url={getImgByPathUrl+'?path='+obj[prop]}>
											<Figure.Image 
												style={previewFileStyle}
												src={getImgByPathUrl+'?path='+obj[prop]}
											/>
											</RDownload>
										</Figure>
										<br/>
										</>
										)
									})}
									{obj['Locker Video'] && 
										<Figure>
										<div className="d-flex justify-content-center ">
										<video style={previewFileStyle} controls>
										<source src={getVideoByPathUrl+'?path='+obj['Locker Video']}/>
										</video>
										</div>
										<RDownload fileName={"Locker Video"} url={getVideoByPathUrl+'?path='+obj['Locker Video']}/>
										</Figure>
									}
								</div>
							</Container>
						</Jumbotron>
					:
				<h5 className="text-center text-danger">Upload Failed</h5>
			}
		</>
	)
}
DisplayResult.propTypes = {
	state: PropTypes.object,
	onRestart: PropTypes.func,
};
